import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class MailsService {
  private http = inject(HttpClient)
  private planifyApuUrl = environment.planifyApiUrl

  public getMailsByMlRef(mlRef: string) {
    return this.http.get<any[]>(`${this.planifyApuUrl}/affairs/${mlRef}/mails`)
  }
}
